// Re-export window.posthog set by the HTML snippet — avoids webpack production build issues
export default window.posthog || null;
